export const fetchCompany = (BeURL, showAlert, id, setEmployer) => {
    fetch(`${BeURL}/fetch-company/${id}`, {
        credentials: 'include',
    })
        .then(async res => {
            if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                throw new Error(err.message || `Server ${res.status}`);
            }
            return res.json();
        })
        .then(data => {
            if (data.success) {
                setEmployer(data.company)
            }
            else showAlert(data.message)
        })
        .catch(err => {
            console.error('Error in fetching Employer details:', err);
            showAlert('Trouble in connecting to the Server! Please try again later.');
        })
}